//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { getApiBaseUrl, getCommonHeaders } from './config';
export class Config {
  baseUrl: string;
  recaptchaToken?: string;

  constructor(baseUrl?: string, recaptchaToken?: string) {
    this.baseUrl = baseUrl ?? getApiBaseUrl();
    if (recaptchaToken !== undefined) {
      this.recaptchaToken = recaptchaToken;
    }
  }
}

export class BaseClient {
  protected config: Config;

  constructor(config?: Config) {
    this.config = config || new Config();
  }

  protected getBaseUrl(_defaultUrl: string, baseUrl?: string): string {
    return baseUrl || this.config.baseUrl;
  }

  protected transformOptions(options: RequestInit): Promise<RequestInit> {
    const headers = new Headers(options.headers);
    const common = getCommonHeaders();
    Object.entries(common).forEach(([key, value]) => headers.set(key, value));
    if (this.config.recaptchaToken) {
      headers.set('x-recaptcha-token', this.config.recaptchaToken);
    }
    options.headers = headers;
    return Promise.resolve(options);
  }

  protected transformResult<T>(
    _url: string,
    response: Response,
    processor: (response: Response) => Promise<T>
  ): Promise<T> {
    // Zde můžete přidat vlastní logiku pro transformaci responses
    // např. error handling, logging, atd.
    return processor(response);
  }
}

export class AccessPointCountrySettingClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Získá všechna nastavení zemí pro AccessPoint widget
     * @return OK
     */
    countrySettingsGet(): Promise<SwaggerResponse<AccessPointCountrySettingModel[]>> {
        let url_ = this.baseUrl + "/v1/admin/country-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCountrySettingsGet(_response));
        });
    }

    protected processCountrySettingsGet(response: Response): Promise<SwaggerResponse<AccessPointCountrySettingModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessPointCountrySettingModel[];
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AccessPointCountrySettingModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Aktualizuje nastavení země pro AccessPoint widget
     * @param countryId ID země (CouId)
     * @param body (optional) Data pro aktualizaci
     * @return No Content
     */
    countrySettingsPatch(countryId: number, body?: UpdateAccessPointCountrySettingRequest | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v1/admin/country-settings/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCountrySettingsPatch(_response));
        });
    }

    protected processCountrySettingsPatch(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }
}

export class AdminClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get paginated and filtered list of Widget API keys
     * @param limit (optional) Maximum number of results to return (default: 50, min: 1, max: 1000)
     * @param offset (optional) Number of records to skip (default: 0)
     * @param customerId__Eq (optional) __Filter by customer ID (exact match)__

    ##### Filter CustomerId using operator **Eq**.
     * @param email__Eq (optional) __Filter by email (partial match - LIKE '%email%')__

    ##### Filter Email using operator **Eq**.
     * @param email__Contains (optional) __Filter by email (partial match - LIKE '%email%')__

    ##### Filter Email using operator **Contains**.
     * @param allowedDomain__Eq (optional) __Filter by allowed domain from claims (partial match - LIKE '%domain%')__

    ##### Filter AllowedDomain using operator **Eq**.
     * @param allowedDomain__Contains (optional) __Filter by allowed domain from claims (partial match - LIKE '%domain%')__

    ##### Filter AllowedDomain using operator **Contains**.
     * @param isActive__Eq (optional) __Filter by active status__

    ##### Filter IsActive using operator **Eq**.
     * @return OK
     */
    apiKeysGet(limit?: number | undefined, offset?: number | undefined, customerId__Eq?: number | undefined, email__Eq?: string | undefined, email__Contains?: string | undefined, allowedDomain__Eq?: string | undefined, allowedDomain__Contains?: string | undefined, isActive__Eq?: boolean | undefined): Promise<SwaggerResponse<WidgetApiKeyModel[]>> {
        let url_ = this.baseUrl + "/v1/admin/apiKeys?";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        if (offset === null)
            throw new globalThis.Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
        if (customerId__Eq === null)
            throw new globalThis.Error("The parameter 'customerId__Eq' cannot be null.");
        else if (customerId__Eq !== undefined)
            url_ += "CustomerId__Eq=" + encodeURIComponent("" + customerId__Eq) + "&";
        if (email__Eq === null)
            throw new globalThis.Error("The parameter 'email__Eq' cannot be null.");
        else if (email__Eq !== undefined)
            url_ += "Email__Eq=" + encodeURIComponent("" + email__Eq) + "&";
        if (email__Contains === null)
            throw new globalThis.Error("The parameter 'email__Contains' cannot be null.");
        else if (email__Contains !== undefined)
            url_ += "Email__Contains=" + encodeURIComponent("" + email__Contains) + "&";
        if (allowedDomain__Eq === null)
            throw new globalThis.Error("The parameter 'allowedDomain__Eq' cannot be null.");
        else if (allowedDomain__Eq !== undefined)
            url_ += "AllowedDomain__Eq=" + encodeURIComponent("" + allowedDomain__Eq) + "&";
        if (allowedDomain__Contains === null)
            throw new globalThis.Error("The parameter 'allowedDomain__Contains' cannot be null.");
        else if (allowedDomain__Contains !== undefined)
            url_ += "AllowedDomain__Contains=" + encodeURIComponent("" + allowedDomain__Contains) + "&";
        if (isActive__Eq === null)
            throw new globalThis.Error("The parameter 'isActive__Eq' cannot be null.");
        else if (isActive__Eq !== undefined)
            url_ += "IsActive__Eq=" + encodeURIComponent("" + isActive__Eq) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiKeysGet(_response));
        });
    }

    protected processApiKeysGet(response: Response): Promise<SwaggerResponse<WidgetApiKeyModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WidgetApiKeyModel[];
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<WidgetApiKeyModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get detail of a specific Widget API key
     * @param id Widget API key ID
     * @return OK
     */
    apiKeyGetById(id: number): Promise<SwaggerResponse<AdminWidgetApiKeyResponseModel>> {
        let url_ = this.baseUrl + "/v1/admin/apiKeys/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiKeyGetById(_response));
        });
    }

    protected processApiKeyGetById(response: Response): Promise<SwaggerResponse<AdminWidgetApiKeyResponseModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminWidgetApiKeyResponseModel;
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AdminWidgetApiKeyResponseModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Deactivate a Widget API key (admin only)
     * @param id Widget API key ID
     * @return No Content
     */
    deactivate(id: number): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v1/admin/widget-keys/{id}/deactivate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }
}

export class InfoClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return OK
     */
    info(): Promise<SwaggerResponse<XElementApplicationInfo>> {
        let url_ = this.baseUrl + "/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInfo(_response));
        });
    }

    protected processInfo(response: Response): Promise<SwaggerResponse<XElementApplicationInfo>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementApplicationInfo;
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not Modified", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Forbidden", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<XElementApplicationInfo>>(new SwaggerResponse(status, _headers, null as any));
    }
}

export class LandingClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: Config, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Create a new Widget API key
     * @param body (optional) Request containing customer ID and email
     * @return Accepted
     */
    apiKeyRequest(body?: CreateWidgetApiKeyRequest | undefined): Promise<SwaggerResponse<WidgetApiKeyModel>> {
        let url_ = this.baseUrl + "/v1/api-key-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiKeyRequest(_response));
        });
    }

    protected processApiKeyRequest(response: Response): Promise<SwaggerResponse<WidgetApiKeyModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WidgetApiKeyModel;
            return new SwaggerResponse(status, _headers, result202);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<WidgetApiKeyModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Request magic link for editing API key settings
     * @param body (optional) Request containing registered email
     * @return Accepted
     */
    magicLinkRequest(body?: MagicLinkRequest | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v1/magic-link-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMagicLinkRequest(_response));
        });
    }

    protected processMagicLinkRequest(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Activate token and create session
     * @param body (optional) Request containing magic link token
     * @return OK
     */
    activate(body?: ActivateTokenRequest | undefined): Promise<SwaggerResponse<ConfirmResultModel>> {
        let url_ = this.baseUrl + "/v1/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivate(_response));
        });
    }

    protected processActivate(response: Response): Promise<SwaggerResponse<ConfirmResultModel>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConfirmResultModel;
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Conflict", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ConfirmResultModel>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get Widget API keys using session cookie
     * @return OK
     */
    apiKeys(): Promise<SwaggerResponse<WidgetApiKeyModel[]>> {
        let url_ = this.baseUrl + "/v1/api-keys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiKeys(_response));
        });
    }

    protected processApiKeys(response: Response): Promise<SwaggerResponse<WidgetApiKeyModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WidgetApiKeyModel[];
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<WidgetApiKeyModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get Widget API key claims using session cookie
     * @param x_Widget_Key (optional) Widget API key from X-Widget-Key header
     * @return OK
     */
    apiKeyClaimsGet(x_Widget_Key?: string | undefined): Promise<SwaggerResponse<WidgetApiKeyClaimModel[]>> {
        let url_ = this.baseUrl + "/v1/api-key-claims";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Widget-Key": x_Widget_Key !== undefined && x_Widget_Key !== null ? "" + x_Widget_Key : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiKeyClaimsGet(_response));
        });
    }

    protected processApiKeyClaimsGet(response: Response): Promise<SwaggerResponse<WidgetApiKeyClaimModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WidgetApiKeyClaimModel[];
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<WidgetApiKeyClaimModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Update Widget API key claims using session cookie
     * @param x_Widget_Key (optional) Widget API key from X-Widget-Key header
     * @param body (optional) Request containing claims to update
     * @return No Content
     */
    apiKeyClaimsPut(x_Widget_Key?: string | undefined, body?: UpdateWidgetApiKeyClaimsRequest | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v1/api-key-claims";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "X-Widget-Key": x_Widget_Key !== undefined && x_Widget_Key !== null ? "" + x_Widget_Key : "",
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApiKeyClaimsPut(_response));
        });
    }

    protected processApiKeyClaimsPut(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get countries available for widget selection
     * @return OK
     */
    widgetCountries(): Promise<SwaggerResponse<WidgetCountryModel[]>> {
        let url_ = this.baseUrl + "/v1/widget-countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processWidgetCountries(_response));
        });
    }

    protected processWidgetCountries(response: Response): Promise<SwaggerResponse<WidgetCountryModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WidgetCountryModel[];
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<WidgetCountryModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Získá seznam typů výdejních míst. Tento endpoint je využíván landing page.
     * @return OK
     */
    accesspointTypes(): Promise<SwaggerResponse<AccessPointTypeModel[]>> {
        let url_ = this.baseUrl + "/v1/accesspoint-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAccesspointTypes(_response));
        });
    }

    protected processAccesspointTypes(response: Response): Promise<SwaggerResponse<AccessPointTypeModel[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessPointTypeModel[];
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<AccessPointTypeModel[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Logout - clear session cookie and delete session
     * @return No Content
     */
    logout(): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/v1/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLogout(_response));
        });
    }

    protected processLogout(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("BadRequest", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("NotFound", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("InternalServerError", status, _responseText, _headers, result500);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as XElementValidationError;
            return throwException("ServiceUnavailable", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }
}

/** Injected nullable object */
export interface EmptyNullableObject {

    [key: string]: any;
}

/** Model pro nastavení země pro AccessPoint widget */
export interface AccessPointCountrySettingModel {
    /** ID země (CouId) */
    id: number;
    /** Kód země */
    countryCode: string;
    /** Názvy země v různých jazycích */
    names: TranslatedName[];
    /** Aktivní dovolená - validace svátků/dovolených */
    holidayValidation: boolean;
    /** Obsazenost VM - validace kapacity výdejního místa */
    capacityValidation: boolean;
    /** Rozměry - validace rozměrů zásilky */
    sizeValidation: boolean;
    /** Váha - validace hmotnosti zásilky */
    weightValidation: boolean;
    /** AgeCheck - validace věku příjemce */
    ageCheckValidation: boolean;
    /** Možnost platby online - viditelnost informace o online platbě */
    onlinePaymentVisible: boolean;
    /** Přijímané velikosti - viditelnost informace o akceptovaných velikostech */
    sizeAcceptanceVisible: boolean;
    /** Kapacita výdejního místa - viditelnost informace o kapacitě */
    capacityVisible: boolean;
    /** Limit úložní doby - viditelnost informace o době uložení */
    storageTimeVisible: boolean;
    /** Dostupná kapacita - filtr podle dostupné kapacity */
    capacityFilter: boolean;
    /** Min. délka úložní doby - filtr podle minimální doby uložení */
    minimalStorageTimeFilter: boolean;
    /** Zda je země dostupná pro widget */
    availableForWidget: boolean;
    /** Zda je země pro widget výchozí */
    defaultForWidget: boolean;
    /** Výchozí jazyk ve formátu ISO 639-1 */
    defaultLanguage: string | undefined;
    /** Výchozí zeměpisná šířka pro centrování mapy widgetu */
    widgetLatitude: number | undefined;
    /** Výchozí zeměpisná délka pro centrování mapy widgetu */
    widgetLongitude: number | undefined;
    /** Výchozí úroveň zoomu mapy */
    widgetZoomLevel: number | undefined;
    /** Časové pásmo ve formátu IANA tz db (např. Europe/Prague) */
    ianaTimeZone: string | undefined;
}

/** Model typu výdejního místa (Access Point Type). */
export interface AccessPointTypeModel {
    /** Kód typu výdejního místa (např. PPL_SHOP, PPL_BOX_V1, atd.). */
    code: string;
    /** Název typu výdejního místa. */
    name: string;
    /** Indikuje, zda je tento typ výdejního místa typu SmartToBox. */
    smartToBox: boolean;
}

/** Request model for activating a magic link token */
export interface ActivateTokenRequest {
    /** The magic link token from the email */
    token: string;
}

/** Response model for admin widget API keys listing */
export interface AdminWidgetApiKeyResponseModel {
    /** Internal ID of the API key */
    id: number;
    /** API key value (partially masked for security) */
    apiKey: string;
    /** Customer ID */
    customerId: number;
    /** Email address registered for this API key */
    email: string;
    /** Indicates whether the registration email matches the official customer email in EPS */
    emailMatch: boolean;
    /** List of allowed shop URLs from widget configuration (AllowedDomain claims) */
    shopUrls: string[] | undefined;
    /** Creation timestamp */
    created: Date;
    /** Indicates whether the API key is active */
    isActive: boolean;
}

/** Response model for token activation including session info */
export interface ConfirmResultModel {
    /** Type of activation token that was used.
Possible values:
<list type="bullet"><item><term>NewKeyActivation</term><description>Token from the new API key creation flow. `apiKey` field is populated.</description></item><item><term>EditAccess</term><description>Token from the magic link edit flow. `apiKey` field is null.</description></item></list> */
    tokenType: string | undefined;
    /** * OpenApi schema overriden - force set to OneOf with nullable entry */
    apiKey: WidgetApiKeyModel | undefined;
    /** Session identifier — use as X-Session header value in subsequent requests */
    sessionId: string | undefined;
    /** UTC expiration time of the session */
    expiresAt: Date;
}

/** Request model for creating a new Widget API key */
export interface CreateWidgetApiKeyRequest {
    /** Customer ID for which the API key should be created (optional). */
    customerId: number | undefined;
    /** Organization ID (IČ) for which the API key should be created (required). */
    orgId: string;
    /** Email address to register the API key for */
    email: string;
}

/** Request model for requesting a magic link for editing API keys */
export interface MagicLinkRequest {
    /** Email address associated with the API keys */
    email: string;
}

/** Překlad názvu (jazyk + přeložený text). Používá se pro uchování názvů zemí ve více jazycích. */
export interface TranslatedName {
    /** Kód jazyka ve formátu ISO 639-1 (např. "cs", "en"). */
    language: string | undefined;
    /** Přeložený název v uvedeném jazyce. */
    name: string | undefined;
}

/** Request model pro aktualizaci nastavení země pro AccessPoint widget */
export interface UpdateAccessPointCountrySettingRequest {
    /** Názvy země v různých jazycích */
    names: TranslatedName[] | undefined;
    /** Aktivní dovolená - validace svátků/dovolených */
    holidayValidation: boolean | undefined;
    /** Obsazenost VM - validace kapacity výdejního místa */
    capacityValidation: boolean | undefined;
    /** Rozměry - validace rozměrů zásilky */
    sizeValidation: boolean | undefined;
    /** Váha - validace hmotnosti zásilky */
    weightValidation: boolean | undefined;
    /** AgeCheck - validace věku příjemce */
    ageCheckValidation: boolean | undefined;
    /** Možnost platby online - viditelnost informace o online platbě */
    onlinePaymentVisible: boolean | undefined;
    /** Přijímané velikosti - viditelnost informace o akceptovaných velikostech */
    sizeAcceptanceVisible: boolean | undefined;
    /** Kapacita výdejního místa - viditelnost informace o kapacitě */
    capacityVisible: boolean | undefined;
    /** Limit úložní doby - viditelnost informace o době uložení */
    storageTimeVisible: boolean | undefined;
    /** Dostupná kapacita - filtr podle dostupné kapacity */
    capacityFilter: boolean | undefined;
    /** Min. délka úložní doby - filtr podle minimální doby uložení */
    minimalStorageTimeFilter: boolean | undefined;
    /** Zda je země dostupná pro widget */
    availableForWidget: boolean | undefined;
    /** Zda je země pro widget výchozí */
    defaultForWidget: boolean | undefined;
    /** Výchozí jazyk ve formátu ISO 639-1 */
    defaultLanguage: string | undefined;
    /** Výchozí zeměpisná šířka pro centrování mapy widgetu */
    widgetLatitude: number | undefined;
    /** Výchozí zeměpisná délka pro centrování mapy widgetu */
    widgetLongitude: number | undefined;
    /** Výchozí úroveň zoomu mapy */
    widgetZoomLevel: number | undefined;
    /** Časové pásmo ve formátu IANA tz db (např. Europe/Prague) */
    ianaTimeZone: string | undefined;
}

/** Request model for updating Widget API key claims */
export interface UpdateWidgetApiKeyClaimsRequest {
    /** List of claims to update */
    claims: WidgetApiKeyClaimModel[];
}

/** Widget API key claim model */
export interface WidgetApiKeyClaimModel {
    claimType: WidgetClaimType;
    /** Claim value */
    claimValue: string;
}

/** Widget API key model */
export interface WidgetApiKeyModel {
    /** Internal ID of the API key */
    id: number;
    /** API key value */
    apiKey: string;
    /** Customer ID */
    customerId: number;
    /** Email address registered for this API key */
    email: string;
    /** List of allowed domains (shop URLs) for this API key */
    shopUrls: string[] | undefined;
    /** Creation timestamp */
    created: Date;
    /** Whether the API key is active */
    isActive: boolean;
}

/** Types of claims that can be associated with a Widget API key. Each claim type has specific cardinality rules that must be followed. */
export enum WidgetClaimType {
    CustomerId = "CustomerId",
    DisabledAccessPointType = "DisabledAccessPointType",
    AllowedAccessPointType = "AllowedAccessPointType",
    AllowedDomain = "AllowedDomain",
    CountryCode = "CountryCode",
    DefaultLanguage = "DefaultLanguage",
    ViewMode = "ViewMode",
    DefaultCountry = "DefaultCountry",
    Smart2Box = "Smart2Box",
}

/** Země dostupná pro widget (zkrácený model pro landing page editor) */
export interface WidgetCountryModel {
    /** Kód země (např. "CZ", "SK") */
    countryCode: string;
    /** Názvy země v různých jazycích */
    names: TranslatedName[];
}

export interface XElementApplicationInfo {
    version: string | undefined;
    state: string | undefined;
    time: Date;
    node: string | undefined;
    application: string | undefined;
    versionDescription: string | undefined;
    product: string | undefined;
}

export interface XElementCoreProblemJsonSchema {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export interface XElementInternalError {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export interface XElementValidationError {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    errors: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

/**
 * Extension code pro NSwag generované klienty
 * Tento soubor obsahuje základní třídy a konfigurace pro API klienty
 */

/**
 * Základní konfigurace pro API klienty
 */

/**
 * Základní třída pro všechny API klienty
 * Poskytuje společnou funkčnost pro transformaci requestů a responses
 */

// ApiException je generována NSwagem do types.ts
// Zde ji nemusíme definovat